import { render, staticRenderFns } from "./extensionCard.vue?vue&type=template&id=7fe73f1f&scoped=true&"
import script from "./extensionCard.vue?vue&type=script&lang=js&"
export * from "./extensionCard.vue?vue&type=script&lang=js&"
import style0 from "./extensionCard.vue?vue&type=style&index=0&id=7fe73f1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe73f1f",
  null
  
)

export default component.exports